export default __webpack_public_path__ + "static/binge-eating-0438d18d00e9c1fac59401ae7a91071f.pdf";